/* =====================================================================
   UUGI — Mobile nav drawer (shared)

   This is the single owner of the #navBurger drawer behaviour.

   gulpfile.js concatenates every script under js/ into one site.min.js
   that _Layout.cshtml loads on every page, so a copy of this block living
   in each page script would register once per bundled script. Each click
   would then toggle the drawer N times and an even N left it closed.
   Keep this logic here only — do not re-add it to the page scripts.
   ===================================================================== */

$(function () {

  var $burger = $('#navBurger');
  var $menu = $('#navMenu');
  if (!$burger.length || !$menu.length) return;

  function closeMenu() {
    $menu.removeClass('is-open');
    $burger.attr('aria-expanded', 'false').attr('aria-label', 'Open menu');
    $('body').removeClass('nav-open');
  }
  function openMenu() {
    $menu.addClass('is-open');
    $burger.attr('aria-expanded', 'true').attr('aria-label', 'Close menu');
    $('body').addClass('nav-open');
  }

  $burger.on('click', function () {
    if ($menu.hasClass('is-open')) closeMenu();
    else openMenu();
  });

  // Close drawer on link click
  $menu.on('click', 'a', function () {
    if ($menu.hasClass('is-open')) closeMenu();
  });

  // Esc closes drawer
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $menu.hasClass('is-open')) closeMenu();
  });

});
